/**
 *  The positions contain IDs of events at that position
 */
import React from "react";
import { FiCheckCircle, FiAlertTriangle, FiCircle } from "react-icons/fi";

export const AdSection = ({
  id,
  index,
  title,
  adsList,
  event_id,
  position,
  setAdsList,
  setRefill,
}) => {
  // Pick a selection (logic preserved)
  const pick = (posIndex) => {
    const builder = adsList.map((ad) => ({
      event_id: ad.event_id,
      position_number: ad.position_number,
      position_type: ad.position_type,
      status: ad.status,
    }));

    // Already selected for this section?
    const isSelected = builder.some(
      (v) => v.position_type === id && v.position_number === posIndex
    );

    // Keep other sections; update this section
    const temp = builder.filter((v) => v.position_type !== id);

    if (!isSelected) {
      temp.push({
        position_number: posIndex,
        event_id: event_id,
        status: 1,
        position_type: id,
      });
    }

    setRefill(false);
    setAdsList(temp);
  };

  return (
    <section className="w-full">
      {/* Section header */}
      <div className="mt-4 mb-2">
        <h4 className="text-sm font-semibold tracking-tight text-gray-900">
          {title}
        </h4>
      </div>

      {/* Four-slot grid */}
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {[0, 1, 2, 3].map((val) => {
          const state =
            position[val] !== null
              ? position[val] === event_id
                ? "current"
                : "taken"
              : "empty";
          return (
            <Position
              key={`pos-${id}-${val}`}
              action={state}
              index={val + 1}
              onClick={() => pick(val + 1)}
            />
          );
        })}
      </div>

      <div className="my-3 h-px w-full bg-gray-100" />
    </section>
  );
};

const Position = ({ action, index, onClick }) => {
  // Visual tokens by state (white-mode only)
  const styles = {
    empty:
      "border-gray-200 bg-white text-gray-700 hover:bg-gray-50 focus-visible:ring-gray-300",
    taken:
      "border-red-200 bg-red-50 text-red-700 hover:bg-red-100 focus-visible:ring-red-300",
    current:
      "border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 focus-visible:ring-emerald-300",
  };

  const icon =
    action === "current"
      ? FiCheckCircle
      : action === "taken"
        ? FiAlertTriangle
        : FiCircle;

  const label =
    action === "current"
      ? "Current"
      : action === "taken"
        ? "Taken — click to override"
        : "Empty — assign here";

  const Icon = icon;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Position ${index}: ${label}`}
      className={[
        "relative inline-flex h-12 w-full items-center justify-between rounded-xl border px-3 py-2",
        "text-xs font-semibold shadow-sm transition",
        "focus:outline-none focus-visible:ring-2",
        styles[action],
      ].join(" ")}
    >
      <span className="flex items-center gap-2">
        <Icon className="h-4 w-4" aria-hidden="true" />
        <span className="whitespace-nowrap">Position {index}</span>
      </span>
      <span className="text-[11px] font-medium opacity-80">{label}</span>
    </button>
  );
};
